<template>
  <div class="foot_map ">
    <div class="w1200 content">
      <div class="p1">
        ©2019彭祖世家网·《彭祖世家总谱·事典》总谱官网及门户网站 Pengzushijia.COM 彭祖世家文化发展有限公司 <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgba(255, 255, 255, 0.7);">粤ICP备19063974号</a> 技术支持：武汉聚脉网络科技有限公司
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .foot_map{
        height: 35px;
        text-align: center;
        font-size: 14px;
        color: #979696;
        padding-top: 15px;
        background: #35383B;
        width: 100%;
        padding-bottom:15px;
        .content{
            background-color: #35383B;
            .p1{
                margin-top: 10px;
            }
            .p2{
                margin-top: 3px;
            }
        }
    }
</style>
